/**
 * Created by Bart Decorte
 * Date: 11/05/2020
 * Time: 19:08
 */
import EpochFilter from './EpochFilter';

export default class DateFilter extends EpochFilter {
  constructor($root) {
    const params = {};
    params.format = 'd/m/Y';
    super($root, params);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/DateFilter.js